import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-505668fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "AVISO DE PRIVACIDAD", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode()
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Iris CF - Compañía de Financiamiento S.A. es un establecimiento de crédito vigilado por la Superintendencia Financiera de Colombia. Este mensaje y/o sus anexos son para uso exclusivo de su destinatario intencional y puede contener información legalmente protegida por ser privilegiada o confidencial. Si usted no es el destinatario intencional del mensaje por favor infórmenos de inmediato y elimine el mensaje y sus anexos de su computador y sistema de comunicaciones. Igualmente, le comunicamos que cualquier retención, revisión no autorizada, distribución, divulgación, reenvío, copia, impresión, reproducción, o uso indebido de este mensaje y/o de sus anexos, está estrictamente prohibida y sancionada legalmente. Iris CF - Compañía de Financiamiento S.A. no asume responsabilidad sobre las opiniones y criterios expresados en este mensaje ( salvo certificación en contrario ) y tampoco garantiza que su contenido y archivos adjuntos estén libres de virus e interferencias. ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signature" }, [
  /*#__PURE__*/_createTextVNode(" Atentamente,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Iris CF - Compañía de Financiamiento S.A. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: $setup.showPrivacityDialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.showPrivacityDialog) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "custom-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, {
            class: "scroll-container",
            ref: "scrollContainer",
            onScroll: $setup.checkScroll
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onScroll"]),
          _createVNode(_component_q_card_actions, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                onClick: $setup.handleConfirm,
                label: "Confirmar",
                class: "rc-btn_primary",
                disabled: !$setup.fullScroll
              }, null, 8, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}